import { ProductAPI } from '@/clients/product/product.api'
export default {
    namespaced: true,
    state: {
        productListPage: 1,
        productListPageCount: 1,
        productListPerPage: 10,
        productListSearch: '',
        addPop: false,
        editPop: false,
        editObj: {},
        list: [],
        activeItem: {},
        activeComponent: '',
        sectionType: 'list',

        cannabisAttributePop: false,
        cannabisAttributeObj: {},

        productImagesPopup: false,
        productImagesObj: {},

        // sync
        syncTerpenesPopup: false,
        syncTerpenesObj: {},

        syncAromasPopup: false,
        syncAromasObj: {},

        syncColoursPopup: false,
        syncColoursObj: {},

        syncFlavoursPopup: false,
        syncFlavoursObj: {},

        syncMoodsPopup: false,
        syncMoodsObj: {},

        syncAllergensPopup: false,
        syncAllergensObj: {},

        cbdLevelPopUp: false,
        cbdLevelObj: {}

    },
    getters: {
        productListPage: state => state.productListPage,
        productListPageCount: state => state.productListPageCount,
        productListPerPage: state => state.productListPerPage,
        productListSearch: state => state.productListSearch,
        addPop: state => state.addPop,
        editPop: state => state.editPop,
        activeItem: state => state.activeItem,
        activeComponent: state => state.activeComponent,
        sectionType: state => state.sectionType,
        editObj: state => state.editObj,
        list: state => state.list,
        cannabisAttributePop: state => state.cannabisAttributePop,
        cannabisAttributeObj: state => state.cannabisAttributeObj,

        productImagesPopup: state => state.productImagesPopup,
        productImagesObj: state => state.productImagesObj,

        syncTerpenesPopup: state => state.syncTerpenesPopup,
        syncTerpenesObj: state => state.syncTerpenesObj,

        syncAromasPopup: state => state.syncAromasPopup,
        syncAromasObj: state => state.syncAromasObj,

        syncColoursPopup: state => state.syncColoursPopup,
        syncColoursObj: state => state.syncColoursObj,

        syncFlavoursPopup: state => state.syncFlavoursPopup,
        syncFlavoursObj: state => state.syncFlavoursObj,

        syncMoodsPopup: state => state.syncMoodsPopup,
        syncMoodsObj: state => state.syncMoodsObj,

        syncAllergensPopup: state => state.syncAllergensPopup,
        syncAllergensObj: state => state.syncAllergensObj,

        cbdLevelPopUp: state => state.cbdLevelPopUp,
        cbdLevelObj: state => state.cbdLevelObj

    },
    mutations: {
        mutateProductListPage(state, data) {
            state.productListPage = data
        },
        mutateProductListPageCount(state, data) {
            state.productListPageCount = data
        },
        mutateProductListPerPage(state, data) {
            state.productListPerPage = data
        },
        mutateProductListSearch(state, data) {
            state.productListSearch = data
        },
        mutateAddPop(state, data) {
            state.addPop = data
            // If add is on edit is false
            state.editPop = false
        },
        mutateEditPop(state, data) {
            state.editPop = data
            // If Edit is on add is false
            state.addPop = false
        },
        mutateActiveItem(state, data) {
            state.activeItem = data
        },
        mutateActiveComponent(state, data) {
            state.activeComponent = data
        },
        mutateSectionType(state, data) {
            state.sectionType = data
        },
        mutateEditObj(state, data) {
            state.editObj = data
        },
        mutateList(state, data) {
            state.list = data
        },

        mutateSyncTerpenesPopup(state, data) {
            state.syncTerpenesPopup = data
        },

        mutateSyncTerpenesObj(state, data) {
            state.syncTerpenesObj = data
        },

        mutateCannabisAttributePop(state, data) {
            state.cannabisAttributePop = data
        },

        mutateCannabisAttributeObj(state, data) {
            state.cannabisAttributeObj = data
        },

        mutateProductImagesPopup(state, data) {
            state.productImagesPopup = data
        },

        mutateProductImagesObj(state, data) {
            state.productImagesObj = data
        },

        // Aromas
        mutateSyncAromasPopup(state, data) {
            state.syncAromasPopup = data
        },

        mutateSyncAromasObj(state, data) {
            state.syncAromasObj = data
        },

        // Colours
        mutateSyncColoursPopup(state, data) {
            state.syncColoursPopup = data
        },

        mutateSyncColoursObj(state, data) {
            state.syncColoursObj = data
        },

        // Flavours
        mutateSyncFlavoursPopup(state, data) {
            state.syncFlavoursPopup = data
        },

        mutateSyncFlavoursObj(state, data) {
            state.syncFlavoursObj = data
        },

        // Moods
        mutateSyncMoodsPopup(state, data) {
            state.syncMoodsPopup = data
        },

        mutateSyncMoodsObj(state, data) {
            state.syncMoodsObj = data
        },

        // Allergens
        mutateSyncAllergensPopup(state, data) {
            state.syncAllergensPopup = data
        },

        mutateSyncAllergensObj(state, data) {
            state.syncAllergensObj = data
        },

        // CBD
        mutateCbdLevelPopUp(state, data) {
            state.cbdLevelPopUp = data
        },
        mutateCbdLevelObj(state, data) {
            state.cbdLevelObj = data
        },
        clearProductState(state) {
            Object.assign(state, require('./reset/product.json'))
        }

    },
    actions: {
        setProductListPage(context, data) {
            context.commit('mutateProductListPage', data)
        },
        setProductListPageCount(context, data) {
            context.commit('mutateProductListPageCount', data)
        },
        setProductListPerPage(context, data) {
            context.commit('mutateProductListPerPage', data)
        },
        setProductListSearch(context, data) {
            context.commit('mutateProductListSearch', data)
        },
        setAddPop(context, data) {
            context.commit('mutateAddPop', data)
        },
        setEditPop(context, data) {
            context.commit('mutateEditPop', data)
        },
        setActiveItem(context, data) {
            context.commit('mutateActiveItem', data)
        },
        setActiveComponent(context, data) {
            context.commit('mutateActiveComponent', data)
        },
        setSectionType(context, data) {
            context.commit('mutateSectionType', data)
        },
        setEditObj(context, data) {
            context.commit('mutateEditObj', data)
        },
        async setList(context) {
            const { data: { payload } } = await ProductAPI.list()
            context.commit('mutateList', payload)
        },
        setSyncTerpenesPopup(context, data) {
            context.commit('mutateSyncTerpenesPopup', data)
        },
        setSyncTerpenesObj(context, data) {
            context.commit('mutateSyncTerpenesObj', data)
        },
        setCannabisAttributePop(context, data) {
            context.commit('mutateCannabisAttributePop', data)
        },
        setCannabisAttributeObj(context, data) {
            context.commit('mutateCannabisAttributeObj', data)
        },

        setProductImagesPopup(context, data) {
            context.commit('mutateProductImagesPopup', data)
        },

        setProductImagesObj(context, data) {
            context.commit('mutateProductImagesObj', data)
        },

        // Aromas
        setSyncAromasPopup(context, data) {
            context.commit('mutateSyncAromasPopup', data)
        },
        setSyncAromasObj(context, data) {
            context.commit('mutateSyncAromasObj', data)
        },

        // Coloirs
        setSyncColoursPopup(context, data) {
            context.commit('mutateSyncColoursPopup', data)
        },
        setSyncColoursObj(context, data) {
            context.commit('mutateSyncColoursObj', data)
        },

        // Flavours
        setSyncFlavoursPopup(context, data) {
            context.commit('mutateSyncFlavoursPopup', data)
        },
        setSyncFlavoursObj(context, data) {
            context.commit('mutateSyncFlavoursObj', data)
        },

        // Moods
        setSyncMoodsPopup(context, data) {
            context.commit('mutateSyncMoodsPopup', data)
        },
        setSyncMoodsObj(context, data) {
            context.commit('mutateSyncMoodsObj', data)
        },

        // Allergens
        setSyncAllergensPopup(context, data) {
            context.commit('mutateSyncAllergensPopup', data)
        },
        setSyncAllergensObj(context, data) {
            context.commit('mutateSyncAllergensObj', data)
        },

        // CBD

        setCbdLevelPopUp(context, data) {
            context.commit('mutateCbdLevelPopUp', data)
        },
        setCbdLevelObj(context, data) {
            context.commit('mutateCbdLevelObj', data)
        }

    }
}
